import { TableProps } from '@ui-system/interfaces-table';

const defaultProps: Partial<TableProps> = {};

export default defaultProps;
